'use client';

import React, { useState } from 'react';
import { clsx } from 'clsx';

interface ProductImageProps {
  /** Full image URL (resolved by the caller) */
  src: string | null;
  alt: string;
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

const sizeClasses: Record<string, string> = {
  xs: 'w-8 h-8',
  sm: 'w-12 h-12',
  md: 'w-16 h-16',
  lg: 'w-20 h-20',
};

export function ProductImage({
  src,
  alt,
  className,
  size = 'md',
}: ProductImageProps) {
  const [hasError, setHasError] = useState(false);

  return (
    <div
      className={clsx(
        sizeClasses[size],
        'bg-zinc-50 rounded-lg border border-zinc-100 flex items-center justify-center shrink-0 overflow-hidden',
        className
      )}
    >
      {hasError || !src ? (
        <span className="text-[10px] text-zinc-400 font-mono uppercase">
          IMG
        </span>
      ) : (
        <img
          src={src}
          alt={alt}
          className="w-full h-full object-contain p-1"
          onError={() => setHasError(true)}
          loading="lazy"
        />
      )}
    </div>
  );
}
